import { useEffect, useState } from "react";
import { useDealer } from "../../../../../../../tools/api";
import { Table } from "antd";
import { NotFound } from "../../../../../../../sources/svg/svg";
import { convertToJalaliWithTime, formatDate } from "../../../../../../../tools/tools";

const ChangeSimCard = ({ purchase = {} }) => {
	const { querySWPurchaseBySPPurchaseId } = useDealer();

	const [csState, setCSState] = useState({
		ListChangeSimCard: [],
		currentPage: 0,
		totalRecord: 0,
		isLoading: true,
	});

	useEffect(() => {
		const initial = async () => {
			setCSState((cs) => ({ ...cs, isLoading: true }));

			try {
				const payloadSwap = {
					SPPurchaseId: purchase?.guD_PurchaseProductId,
					search: {
						sort: "",
						filter: "",
						entriesperpage: 10,
						page: csState?.currentPage === 0 ? 0 : csState?.currentPage - 1,
						totalrowcount: 0,
					},
				};
				const responseSwap = await querySWPurchaseBySPPurchaseId(payloadSwap);
				if (responseSwap)
					setCSState((cs) => ({ ...cs, ListChangeSimCard: responseSwap?.Result, totalRecord: responseSwap?.searchconfigmodel?.totalrowcount }));
				setCSState((cs) => ({ ...cs, isLoading: false }));
			} catch (error) {
				setCSState((cs) => ({ ...cs, isLoading: false }));
				console.log(error?.message);
			}
		};
		if (purchase) initial();
	}, [purchase, csState?.currentPage]);

	return (
		<>
			<div className="holder-table" style={{ marginTop: "3rem" }}>
				<Table
					className="tbl-normal"
					loading={csState?.isLoadingList}
					columns={[
						{
							title: "کیت قبلی",
							dataIndex: "oLDICCID",
							key: "oLDICCID",
							width: 150,
						},
						{
							title: "کیت جدید",
							dataIndex: "nEWICCID",
							key: "nEWICCID",
							width: 150,
						},
						{
							title: "تاریخ",
							dataIndex: "operationDate",
							key: "operationDate",
							width: 150,
						},
						{
							title: "وضعیت درخواست",
							dataIndex: "simswapstate",
							key: "simswapstate",
							width: 150,
						},
						{
							title: "علت درخواست",
							dataIndex: "simswapReason",
							key: "simswapReason",
							width: 150,
						},
					]}
					locale={{
						emptyText: (
							<>
								<NotFound text={"رکوردی یافت نشد."} />
							</>
						),
					}}
					scroll={{ y: "100%" }}
					pagination={{
						className: "page-pagination",
						// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
						onChange: (page) => {
							setCSState((cs) => ({ ...cs, currentPage: page }));
						},
						pageSize: 10,
						align: "start",
						current: csState?.currentPage === 0 ? 1 : csState?.currentPage,
						total: csState?.totalRecord,
						showSizeChanger: false,
					}}
					dataSource={csState?.ListChangeSimCard.map((item, key) => ({
						key: key,
						oLDICCID: item?.oLDICCID?.slice(10, 19),
						nEWICCID: item?.nEWICCID?.slice(10, 19),
						operationDate: (
							<>
								{convertToJalaliWithTime(item?.operationDate)} - {formatDate(new Date(item?.operationDate))}
							</>
						),
						simswapstate: item?.simswapstate,
						simswapReason: item?.simswapReason,
					}))}
				/>
			</div>
		</>
	);
};

export default ChangeSimCard;
